import { appDay } from "shared/day";
import { CONSTS } from "../config/objectConst";
import * as files from "shared/files";
import { isValidOnBoardingConditions } from "./function.types";
import { roundToDecimal } from "shared/utils";

export const functions = {
  isDate(value) {
    switch (typeof value) {
      case "number":
        return true;
      case "string":
        return !isNaN(Date.parse(value));
      case "object":
        if (value instanceof Date) {
          return !isNaN(value.getTime());
        }
        break;
      default:
        return false;
    }
  },
  getMonth(monthIndex) {
    const months = [
      "Jan",
      "Feb",
      "Mar",
      "Apr",
      "May",
      "Jun",
      "Jul",
      "Aug",
      "Sep",
      "Oct",
      "Nov",
      "Dec",
    ];
    return months.find((item, index) => index === monthIndex);
  },

  // TODO: Probably could be managed via dayjs
  parseDateToDMY(date, divider = ".") {
    const dateParsed = Date.parse(date);
    const dateObject = new Date(dateParsed);

    if (!dateParsed) {
      return "...";
    }

    // TODO #698 change global date format
    // return `${
    //   dateObject.getMonth() + 1 < 10
    //     ? `0${dateObject.getMonth() + 1}`
    //     : dateObject.getMonth() + 1
    // }${divider}${
    //   dateObject.getDate() < 10
    //     ? `0${dateObject.getDate()}`
    //     : dateObject.getDate()
    // }${divider}${dateObject.getFullYear()}`;

    return appDay(date).format("DD MMM YYYY");
    // return `${
    //   dateObject.getMonth() + 1 < 10
    //     ? `0${dateObject.getMonth() + 1}`
    //     : dateObject.getMonth() + 1
    // }${divider}${
    //   dateObject.getDate() < 10
    //     ? `0${dateObject.getDate()}`
    //     : dateObject.getDate()
    // }${divider}${dateObject.getFullYear()}`;
  },

  validateHours(value) {
    const startTimeInHours = value && value.split("-")[0].split(":")[0];
    const startTimeInMinutes = value && value.split("-")[0].split(":")[1];
    const endTimeInHours = value && value.split("-")[1].split(":")[0];
    const endTimeInMinutes = value && value.split("-")[1].split(":")[1];
    const totalTime = this.getTotalTime(
      Number(startTimeInHours),
      Number(endTimeInHours),
      Number(startTimeInMinutes),
      Number(endTimeInMinutes)
    );

    if (!value) {
      return "Input the time";
    } else if (
      startTimeInMinutes < 0 ||
      endTimeInMinutes < 0 ||
      startTimeInMinutes > 59 ||
      endTimeInMinutes > 59 ||
      startTimeInHours < 0 ||
      startTimeInHours > 24 ||
      endTimeInHours < 0 ||
      endTimeInHours > 24 ||
      startTimeInHours > endTimeInHours ||
      startTimeInHours.indexOf("_") !== -1 ||
      endTimeInHours.indexOf("_") !== -1 ||
      startTimeInMinutes.indexOf("_") !== -1 ||
      endTimeInMinutes.indexOf("_") !== -1
    ) {
      return "Invalid interval format";
    } else if (totalTime / 60 > CONSTS.WORKING_HOURS) {
      return `Total interval can't exceed ${CONSTS.WORKING_HOURS} hours`;
    } else {
      return "";
    }
  },
  getTotalTime(
    startTimeInHours,
    endTimeInHours,
    startTimeInMinutes,
    endTimeInMinutes
  ) {
    if (endTimeInHours === 0) {
      return 24 - startTimeInHours;
    }
    return Math.abs(
      startTimeInHours * 60 +
        startTimeInMinutes -
        (endTimeInHours * 60 + endTimeInMinutes)
    );
  },
  isValidOnBoardingConditions,
  calculatePercentage(number, total) {
    const dimension = 10;
    const result =
      total !== 0
        ? Math.round((number / total + Number.EPSILON) * 100 * dimension) /
          dimension
        : 0;
    return result;
  },
  roundToDecimal,
  getFileName: files.generateName,
};

export const saveData = files.saveFile;
